import React from 'react'
import NavBar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import Topsec from '../../Components/Privacy/Topsec'
import Content from '../../Components/Privacy/Content'

function Privacy() {
  return (
    <div>
        <NavBar/>
        <Topsec/>
        <Content/>
        <Footer/>
    </div>
  )
}

export default Privacy